<template>
  <button
    ref="el"
    class="toggle-item relative block rounded-full px-5 py-2 font-bold text-muted"
    :class="{
      'is-active bg-primary text-white': isActive,
      'hover:text-muted-hover': !isActive,
    }"
    :style="style"
    @click.capture.stop.prevent="setActiveId(toggleId)"
  >
    <span class="relative z-20">{{ title || id }}</span>
  </button>
</template>

<script lang="ts" setup>
import type { ParagraphToggleItemFragment } from '#graphql-operations'

const props = defineProps<ParagraphToggleItemFragment>()

const { index } = defineBlokkli({
  bundle: 'toggle_item',
})

const el = ref<HTMLButtonElement>()
const toggleId = computed(() => props.id || '')
const { setActiveId, activeToggleId } = usePartyToggle()

const isActive = computed(() => {
  // No active toggle ID means the first toggle is active.
  if (!activeToggleId.value) {
    return index.value === 0
  }

  return activeToggleId.value === toggleId.value
})

const style = computed(() => {
  if (!isActive.value) {
    return
  }
  return {
    'anchor-name': '--toggle-anchor',
  }
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
/* If the browser supports anchor positioning, we can remove the fallback active background. */
@supports (position-anchor: inherit) {
  .toggle-item.is-active {
    @apply !bg-transparent;
  }
}
</style>
